import { useMutation, useQueryClient } from '@tanstack/react-query'
import client from '@/client'
import {
  NOTIFICATION_ENDPOINT,
  NOTIFICATION_INVALIDATE_KEYS,
  NOTIFICATION_QUERY_KEYS
} from '../constants/notification.constants'
import type { CustomEnvelope, NotificationReadResult } from '../types/notification.types'

export const actionMarkNotificationReadRequest = { method: 'POST', path: NOTIFICATION_ENDPOINT.read } as const

/** CUSTOM-NESTJS — tandai satu atau beberapa notifikasi sebagai dibaca (hanya milik user aktif). */
export async function actionMarkNotificationRead(payload: { ids: string[] }): Promise<NotificationReadResult> {
  const response = await client.api.post<CustomEnvelope<NotificationReadResult>>(
    actionMarkNotificationReadRequest.path,
    payload
  )
  return response.data.data
}

export function useActionMarkNotificationRead() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: NOTIFICATION_QUERY_KEYS.mutation('markRead'),
    mutationFn: actionMarkNotificationRead,
    onSuccess: () => {
      NOTIFICATION_INVALIDATE_KEYS.forEach(queryKey => queryClient.invalidateQueries({ queryKey: [...queryKey] }))
    }
  })
}
